export default __webpack_public_path__ + "static/media/3.3.32ed76a7.mp4";